import { useMediaQuery } from "@material-ui/core";

export default function useDesktop() {
  const matches = useMediaQuery("(min-device-width:1024px) and (orientation: landscape)");

  return matches;
}
